import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterRow } from '../search/filterRow.js';
import {
    fetchingAdvancedSearchReset,
    fetchingAdvancedSearchStart,
} from '../../redux/advancedSearch/advancedSearchSlice.js';
import { Card, Button } from '../ui';
import { DivOrSeparator } from '../search/search.styled';
import { FilterRows, FilterActions, FilterError } from './filterPanel.styled';

// Panneau de filtres affiché à plat sur la page, en remplacement du menu déroulant
// « Select your filters ». La logique de déclenchement reprend à l'identique celle
// du composant Search partagé, qui reste utilisé par les pages Users et Diff.
export default function FilterPanel({ filterRow, setFilterRow, setActiveFilters }) {
    const dispatch = useDispatch();
    const { isAdvancedSearchActive, isAdvancedSearchError, messageErrorAdvancedSearch } =
        useSelector((state) => state.advancedSearch);

    const triggerSearch = () => {
        if (!filterRow) return;

        // Une recherche déjà affichée doit être réinitialisée d'abord : le reset vide
        // savedFilters, sans quoi le garde de cache de SearchListResult empêcherait
        // le rafraîchissement. Le délai laisse le reset se propager avant le start.
        if (isAdvancedSearchActive === true) {
            dispatch(fetchingAdvancedSearchReset());
        }
        setActiveFilters([...filterRow]);
        setTimeout(() => {
            dispatch(fetchingAdvancedSearchStart());
        }, 100);
    };

    const addRow = () => {
        const lastRow = filterRow.length > 0 ? filterRow[filterRow.length - 1] : null;
        const newRow = {
            id: filterRow.length + 1,
            operator: 'AND',
            comparator: 'contains',
            information: lastRow ? lastRow.information : 'Users',
            propertie: null,
            input: null,
            action: 'remove',
        };
        setFilterRow([...filterRow, newRow]);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            triggerSearch();
        }
    };

    return (
        <>
            <Card onKeyDown={handleKeyDown}>
                <FilterRows>
                    {filterRow.map((row, k) => (
                        <React.Fragment key={k}>
                            {k > 0 && row.operator === 'OR' && (
                                <DivOrSeparator>
                                    <span>OU — séparateur de groupe</span>
                                </DivOrSeparator>
                            )}
                            <FilterRow
                                filterRow={filterRow}
                                setFilterRow={setFilterRow}
                                buttonAction={row}
                            />
                        </React.Fragment>
                    ))}
                </FilterRows>

                <FilterActions>
                    <Button type="button" $variant="ghost" onClick={addRow}>
                        <i className="bx bx-plus" />
                        Ajouter un filtre
                    </Button>
                    <Button type="button" onClick={triggerSearch}>
                        <i className="bx bx-search" />
                        Rechercher
                    </Button>
                </FilterActions>
            </Card>

            {isAdvancedSearchError && messageErrorAdvancedSearch && (
                <FilterError>{messageErrorAdvancedSearch}</FilterError>
            )}
        </>
    );
}
